<template>
    <div class="profileBox">
        <div class="smallFont">Logged in as</div>
        <div>{{ user.name }}</div>
        <div class="bottom">
            <router-link to="/admin" v-if="user.permissions.admin > 0" class="profile-button admin">Admin Panel</router-link>
            <p v-if="user.permissions.admin > 0">|</p>
            <div v-on:click="logout()" class="profile-button">Log out</div>
        </div>
    </div>
</template>

<script>
  import Velocity from 'velocity-animate'
  import Sizzle from 'sizzle'
  import auth from '~/lib/auth'

  export default {
    props: ['authenticated'],
    data () {
      return {
        user: {
          id: null,
          name: null,
          email: null,
          permissions: {
            admin: 0
          }
        }
      }
    },
    methods: {
      show () {
        Velocity(this.$el, 'fadeIn', { duration: 50 })
      },
      showAdmin () {
        Velocity(Sizzle(this.$el, '.admin'), 'fadeIn', { duration: 50 })
      },
      hide () {
        Velocity(this.$el, 'fadeOut', { duration: 50 })
      },
      logout () {
        auth.logout()
      }
    },
    watch: {
      'authenticated': {
        handler (value) {
          if (value) {
            Object.assign(this.user, auth.user)
            this.show()
            return
          }

          this.hide()
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
    .profileBox {
        display: none;
        float: right;
        padding: 20px;
        height: calc(100% - 40px);
        text-align: center;
        position: relative;
        min-width: 200px;
    }

    .smallFont {
        color: #bab2b2;
        font-size: 0.8em;
    }

    .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;

        .profile-button {
            display: inline;
            font-size: 0.8em;
            text-decoration: none;
            color: #000000;
            cursor: pointer;
        }

        .profile-button:hover {
            color: #bab2b2;
        }

        p {
            display: inline;
        }
    }
</style>


// WEBPACK FOOTER //
// profile.vue?be63b910